module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('Icon', {
    attrs: {
      "size": "big",
      "type": "rooms"
    }
  }), _c('div', {
    staticClass: "block__info"
  }, [_c('div', {
    staticClass: "block__description_show"
  }, [(_vm.item.call_name) ? _c('h3', {
    staticClass: "block__title"
  }, [_vm._v(_vm._s(_vm.item.call_name))]) : _vm._e(), (_vm.getCallTime && _vm.getTime) ? _c('p', {
    staticClass: "block__description_no_margin"
  }, [_vm._v("Состоится " + _vm._s((_vm.getCallTime + " в " + _vm.getTime)))]) : _vm._e(), (_vm.item.chat_creator_fio) ? _c('p', {
    staticClass: "block__description_no_margin"
  }, [_c('b', [_vm._v("Модератор:")]), _vm._v(" " + _vm._s(_vm.item.chat_creator_fio))]) : _vm._e(), (_vm.item.status_rus) ? _c('p', {
    staticClass: "block__description_no_margin"
  }, [_c('b', [_vm._v("Статус:")]), _vm._v(" " + _vm._s(_vm.item.status_rus))]) : _vm._e()])]), _c('div', {
    staticClass: "roomsblock"
  }, [_c('a', {
    staticClass: "roomsblock__link",
    attrs: {
      "target": "_blank",
      "href": _vm.item.call_join_link
    }
  }, [_vm._v("Посмотреть вебинар")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08f62a4c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/infoSferum/InfoSferumWebinar.vue
// module id = dc77442630db9d92fc65
// module chunks = 14